/**
 * JavaScript Document
 * Version: 1.0.0
 * Date: 9/2/2020
 * Author: Liu Changkun
 * Copyright: www.east.net
 */

//UTF-16转UTF-8
export function utf16to8(str) {
  let out, i, len, c;
  out = "";
  len = str.length;
  for (i = 0; i < len; i++) {
    c = str.charCodeAt(i);
    if (c >= 0x0001 && c <= 0x007f) {
      out += str.charAt(i);
    } else if (c > 0x07ff) {
      out += String.fromCharCode(0xe0 | ((c >> 12) & 0x0f));
      out += String.fromCharCode(0x80 | ((c >> 6) & 0x3f));
      out += String.fromCharCode(0x80 | ((c >> 0) & 0x3f));
    } else {
      out += String.fromCharCode(0xc0 | ((c >> 6) & 0x1f));
      out += String.fromCharCode(0x80 | ((c >> 0) & 0x3f));
    }
  }
  return out;
}

//UTF-8转UTF-16
export function utf8to16(str) {
  let out, i, len, c;
  let char2, char3;
  out = "";
  len = str.length;
  i = 0;
  while (i < len) {
    c = str.charCodeAt(i++);
    switch (c >> 4) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
        // 0xxxxxxx
        out += str.charAt(i - 1);
        break;
      case 12:
      case 13:
        // 110x xxxx 10xx xxxx
        char2 = str.charCodeAt(i++);
        out += String.fromCharCode(((c & 0x1f) << 6) | (char2 & 0x3f));
        break;
      case 14:
        // 1110 xxxx 10xx xxxx 10xx xxxx
        char2 = str.charCodeAt(i++);
        char3 = str.charCodeAt(i++);
        out += String.fromCharCode(
          ((c & 0x0f) << 12) | ((char2 & 0x3f) << 6) | ((char3 & 0x3f) << 0)
        );
        break;
    }
  }
  return out;
}

export function toHex(str) {
  str = utf16to8(str);
  let hex = "";
  for (let i = 0; i < str.length; i++) {
    let c = str.charCodeAt(i);
    hex += c < 16 ? 0 + c.toString(16) : c.toString(16);
  }
  return hex.toUpperCase();
}

export function fromHex(hex) {
  let str = "";
  for (let i = 0; i < hex.length; i += 2) {
    str += String.fromCharCode(parseInt(hex.slice(i, i + 2), 16));
  }
  str = utf8to16(str);
  return str;
}

export function escapeSplit(str, char) {
  let arr = [];
  str.split(char).forEach(function(item) {
    if (arr.length && arr[arr.length - 1].endsWith("\\")) {
      arr[arr.length - 1] += char + item;
    } else {
      arr.push(item);
    }
  });
  return arr;
}

export function escapeName(str) {
  ["\\", '"', "+", ",", ";", "<", ">", " ", "#", "="].forEach(function(es) {
    str = str.replace(new RegExp("\\\\\\" + es, "g"), es);
  });
  return str;
}
